import React, { FC } from 'react';

import { CreateListPartial } from '../create-list-partial/CreateListPartial';
import { PartialMessageProps } from '../partial-message/PartialMessage';
import { MultipleEntityMatchesReply } from './MultipleEntityMatchesReply';

export interface MultipleEntityMatchesProps {
  action: string;
  items: [Record<string, string[]>];
  info: Pick<PartialMessageProps, 'data'>['data']['info'];
}

export const MultipleEntityMatches: FC<MultipleEntityMatchesProps> = ({
  items,
  info,
  action,
}) => {
  if (action === 'create-list') {
    return <CreateListPartial items={items} info={info} action={action} />;
  }

  return (
    <MultipleEntityMatchesReply items={items} info={info} action={action} />
  );
};
